// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "134." + {"525":"e0e415b2ee8790986517","726":"fc13acdd110e5d3801a2"}[chunkId] + ".chunk.js";
};